<ng-container *ngIf="typologie === 'autre'">
        <app-typologie-card 
                [EditMode]=true 
                [showFormat]=true 
                [showDimension]=true 
                [showGrammage]=false
                [showFinition]=false 
                [showEncre]=false>
        </app-typologie-card>

        <app-support-grammage-card [typologie]="'autre'"></app-support-grammage-card>
</ng-container>


<ng-container *ngIf="typologie === 'lettre'">
        <app-typologie-lettre-card 
                [EditMode]=true 
                [showFormat]=true 
                [showPage]=true 
                [showDimension]=true 
                [showGrammage]=false
                [showFinition]=false 
                [showEncre]=false>
        </app-typologie-lettre-card>

        <mat-toolbar>
                <h2>Paramétrage de la lettre</h2>
                <button mat-raised-button color="blue" (click)="gotoTypologieSelection()">Terminer</button>
        </mat-toolbar> 

        <app-support-grammage-card [typologie]="'lettre'"></app-support-grammage-card>
</ng-container>

<ng-container *ngIf="typologie === 'enveloppe'">
        <app-typologie-enveloppe-card 
                [EditMode]=true 
                [showFormat]=true 
                [showEnveloppe]=true 
                [showDimension]=true 
                [showGrammage]=false
                [showFinition]=false 
                [showEncre]=false>
        </app-typologie-enveloppe-card>

        <mat-toolbar>
                <h2>Paramétrage de l'enveloppe</h2>
        </mat-toolbar> 

        <app-enveloppe-grammage-card [typologie]="'enveloppe'"></app-enveloppe-grammage-card>        
</ng-container>
